<template>
  <div class="flexwrap centercenter" style="width: 100%">
    <div class="errorPanelIn centercenter" v-if="!changeTranslation&&!other">
      <div>
        Quelle erreur souhaites-tu signaler ?
      </div>
      <div class="proposition plainStandardTheme paddingRound mediumRoundAngles mediumShadow" @click="easyWord()">
        Le mot&thinsp; <span style="color:#59daff">{{ word.lemma.english }}</span> &thinsp;est trop facile pour le
        niveau {{ difficulty(level) }}.
      </div>

      <div class="proposition plainStandardTheme paddingRound mediumRoundAngles mediumShadow"
           @click="changeTranslation=true">
        Le mot &thinsp;<span style="color:#59daff">{{ word.lemma.separateTrads[0] }}</span> &thinsp;n'est pas la
        meilleure traduction de&thinsp; <span style="color:#59daff">{{ word.lemma.english }}</span> &thinsp;pour
        cette phrase.
      </div>

      <div class="proposition plainStandardTheme paddingRound mediumRoundAngles mediumShadow flexcenter"
           @click="other=true">
        Autre
      </div>
    </div>
    <div class="errorPanelIn" v-if="changeTranslation&&!other">
      <div>
        Quelle traduction serait meilleure?
      </div>
      <div class="errorPanelIn" v-if="!otherTrad">
        <div class="proposition plainStandardTheme paddingRound mediumRoundAngles mediumShadow"
             v-for="(option, key) in possibleTranslations"
             v-if="option.separateTrads[0] != word.lemma.separateTrads[0]" @click="postNewTrad(option)">
          {{ option.separateTrads[0] }}
        </div>
        <div class="proposition plainStandardTheme paddingRound mediumRoundAngles mediumShadow" @click="otherTrad=true">
          Autre
        </div>
      </div>
      <div class="errorPanelIn flexwrap centercenter" v-else>
        <textarea class="value-text" v-model="otherTradText"></textarea>
        <div class="proposition plainStandardTheme paddingRound mediumRoundAngles mediumShadow" style="width:30%;"
             @click="postNewTradNote(otherTradText)">
          Envoyer
        </div>
      </div>

    </div>

    <div class="errorPanelIn flexwrap centercenter" v-if="other">
      <div>
        Signale l'erreur dans le champs de texte suivant :
      </div>
      <textarea class="value-text" v-model="otherErrorText"></textarea>
      <div class="proposition plainStandardTheme paddingRound mediumRoundAngles mediumShadow" style="width:30%;"
           @click="sendMail(otherErrorText)">
        Envoyer
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import {API_URL} from "@/App";
import {mapGetters} from 'vuex'
import {lock} from '../main'
//import Popup from "@/components/popup";

export default {
  name: "userModif",
  props: ['showErrorPanel', 'word', 'level'],
  created: function () {
    this.fetchData()
  },
  computed: {
    ...mapGetters('global', [
      'isMobile',
      'profile',
    ]),
    ...mapGetters('show', [
      'currentShow',
      'currentEpisodeData'
    ])
  },
  methods: {
    fetchData: function () {
      const url = `${API_URL}/api/lemma/${this.word.lemma.english}/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.get(url, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {
                return response.data;
              })
              .then(data => {
                    this.possibleTranslations = data;
                    if (this.possibleTranslations.length < 2) {
                      this.otherTrad = true
                    }
                  }
              );
        }
        else {
            console.log(error)
          }
        });
    },
    postNewTrad: function (trad) {
      let payload = {
        "episodelemma": this.word.id,
        "user": this.profile.sub,
        "lemmaold": this.word.lemma.id,
        "lemmanew": trad.id
      }
      const url = `${API_URL}/api/correctionmeaning/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.post(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
          this.deleteWord()
          this.close()
        }
        else {
          console.log(error)
        }
      })
    },
    postNewTradNote(note) {
      let payload = {
        "episodelemma": this.word.id,
        "user": this.profile.sub,
        "lemmaold": this.word.lemma.id,
        "note": note
      }
      const url = `${API_URL}/api/correctionmeaning/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.post(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
          this.deleteWord()
          this.close()
        }
        else {
          console.log(error)
        }
      })
    },
    sendMail: function (note) {
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
          .then(() => {
            // Script is loaded, do something
            window.Email.send({
              Host: "email-smtp.eu-west-2.amazonaws.com",
              Username: "AKIA2VM4R3QQO2FT3O6Z",
              Password: "BNPVx6bdVowNio63dbQBgz9979ZXVAV6CyK/yl8CmpQS",
              To: 'fanny.destenay@learnandwatch.com',
              From: "fanny.destenay@learnandwatch.com",
              Subject: "Signalement d'erreur Learn and Watch",
              Body: 'Erreur signalée : \n' + '\n Série : ' + this.currentShow.french_title + '\n épisode : ' + this.currentEpisodeData.num + ' \n mot : ' + this.word.lemma.english +
                  '\n phrase : ' + this.word.first_sentence.sentence + '\n Id du mot : ' + this.word.lemma.id + '\n note de l\'utilisateur : ' + note + '\n mail de l\'utilisateur : ' + this.profile.email
            }).then(
                message => console.log(message)
            );
          })
          .catch(() => {
            // Failed to fetch script
          });
      this.close();
    },
    easyWord() {
      let payload = {
        "user": this.profile.sub,
        "lemma": this.word.lemma.id
      }
      const url = `${API_URL}/api/correctiondifficulty/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.post(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
          this.deleteWord()
          this.close()
        }
        else {
          console.log(error)
        }
      })
    },
    difficulty: function (difficulty) {

      if (difficulty == 0) {
        return 'A1'
      } else if (difficulty == 1) {
        return 'A2'
      } else if (difficulty == 2) {
        return 'B1'
      } else if (difficulty == 3) {
        return 'B2'
      } else if (difficulty == 4) {
        return 'C1'
      } else {
        return 'C2'
      }
    },
    selected: function (val, key) {
    },
    close: function (val, key) {
      this.$emit('close', false);
    },
    deleteWord: function (val, key) {
      this.$emit('deleteWord', false);
    }
  },
  data() {
    return {
      changeTranslation: false,
      other: false,
      otherTrad: false,
      otherErrorText: "",
      otherTradText: "",
      possibleTranslations: {}
    }
  }
}
</script>

<style scoped>

.errorPanelIn {
  width: 100%;
  height: 100%;
  /*position: relative;*/
  display: grid;
  grid-auto-columns: auto;
  grid-auto-rows: min-content;
  grid-gap: 1.5vw;
  justify-content: center;
  align-content: center;

}

.closeErrorPanel {
  position: absolute;
  font-size: 200%;
  right: 0;
  padding-top: 0.5vw;
  padding-right: 1vw;
  cursor: pointer;
}


.proposition {
  font-size: 100%;
  font-weight: bold;
  min-height: 2.2em;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  text-align: center;
  justify-content: center;
  width: 80%;
}

.proposition > span {
  text-align: center;
  justify-self: center;
}

.value-text:focus {
  outline: none;
}

.value-text {
  display: flex;
  padding-left: 1vw;
  min-width: 20vw;
}

textarea.value-text {
  display: flex;
  padding: 1vw;
  border-radius: 1vw;
  height: 100%;
}
</style>